import React, {useContext} from "react";
import {FormContext} from "./Form";
export function CheckboxField(props) {
  const { name, label, disabled, ...otrasProps } = props;
  const { value, setValue } = useContext(FormContext);
  
  const styles = { display: "flex", alignItems: "center", gap: "0 5px" };

  const currentValue = value(name) === undefined ? false : value(name);

  return (
    <React.Fragment>
      <div style={styles}>
        <div className="checkbox-outer">
          <input
            type="checkbox"
            checked={currentValue}
            onChange={(event) => {
              setValue(name, event.target.checked);
            }}
            disabled={disabled}
          />
        </div>
        <label className="checkbox">{label}</label>
      </div>
    </React.Fragment>
  );
}
